import { Talent, ReportReasonsEnum } from '@libs/graphql-types';
import { OptionType } from '@libs/ui/components/form/select';

export const REPORT_TALENT_MODAL_ID = 'ReportTalentModal';

export type ReportTalentModalData = {
  talent: Partial<Talent>;
};

// Options per Figma spec - using GraphQL enum values
export const REPORT_TALENT_REASONS: OptionType[] = [
  {
    value: ReportReasonsEnum.DiscriminationHateSpeech,
    text: 'Discrimination or hate speech',
  },
  {
    value: ReportReasonsEnum.InappropriateBehavior,
    text: 'Inappropriate behavior',
  },
  {
    value: ReportReasonsEnum.Harassment,
    text: 'Harassment',
  },
  {
    value: ReportReasonsEnum.SpamFakeProfile,
    text: 'Spam or fake profile',
  },
  {
    value: ReportReasonsEnum.Other,
    text: 'Other',
  },
];
